import { DictionaryItem } from '@/Types/api/Dictionaries';

import { ListItemModel } from '../model/ListItemModel';

export const mapDictionaryItemToListItemModel = (dictionaryItem: DictionaryItem, busyIds: number[] = []): ListItemModel => {
    const isDisabled = busyIds.includes(dictionaryItem.id);

    return {
        title: dictionaryItem.name,
        entityId: dictionaryItem.id,
        isSelected: false,
        isDisabled,
    };
};
